import Axios from "axios";
export const SelectClient = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/CLIENTs?coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "CLIENT_SELECT", payload: response.data });
    });
  };
};
